export default "//cloud.imgsmail.ru/cloud.mail.ru/129209/img/build/quota-landing/googlePlay.png";